import { ErrorHandler, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { PagerBaseComponent } from '~/app/open-age/core/structures';
import { Division } from '../models';
import { DivisionService } from '../services';

export class DivisionListBaseComponent extends PagerBaseComponent<Division> implements OnInit, OnDestroy, OnChanges {

    @Input()
    readonly = false;

    @Input()
    status: string;

    @Input()
    name: string;

    @Input()
    sort = 'code';

    constructor(
        api: DivisionService,
        errorHandler: ErrorHandler
    ) {
        super({
            api,
            errorHandler,
            pageOptions: { limit: 10, isDecrypt: true },
            filters: ['name', 'status'],
        });
    }

    ngOnInit() {
        this.fetch();
    }

    ngOnChanges(): void {
        // this.filters.set('status', this.status);
        this.filters.set('name', this.name);
        this.fetch();

    }

    ngOnDestroy(): void { }
}
